export type CameraAppVersionID = number;

export interface CameraAppVersion {
  created_on: string;
  updated_on: string;
  id: CameraAppVersionID;
  label: string;
  minimum_label: string;
  remarks: string;
}
